module.exports = __webpack_public_path__ + "img/Image_04.c56693ef.jpg";